import {createSelector} from 'reselect';

export const rootRequestPageSelector = (state) => state.requestPage;

export const isRequestPageLoadingSelector = createSelector(
    rootRequestPageSelector,
    page => page.manager.loading > 0,
);
